import { FC, ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

import LatestIndexPage from '@/apps/latest/pages'
import HomecareHomePage from '@/apps/latest/pages/homecare/home'
import HomecarePatientPage from '@/apps/latest/pages/homecare/patient'
import HomecarePlanPage from '@/apps/latest/pages/homecare/plan'
import { useIsDietitian, useReleaseChannel } from '@/features/auth'
import { useAppType } from '@/shared/contexts/AppTypeContext'
import { isLegacyApp } from '@/types/appType'

// 在宅 (左ナビ「在宅」) は latest shell の α (共同開発版) の機能。legacy は凍結シェルのため導線も画面も持たない。
// URL 直打ちで来た非対象ユーザー (legacy・α でない・管理栄養士) はホームへ返す
// (nav の gate と route の gate を一致させる)。setting 読込中は判定を保留する。
const Gate: FC<{ children: ReactElement }> = ({ children }) => {
  const { appType, isLoading } = useAppType()
  const { isAlpha } = useReleaseChannel()
  const { isDietitian, isResolved } = useIsDietitian()

  if (isLoading || !isResolved) return null
  if (isLegacyApp(appType) || !isAlpha || isDietitian) {
    return <Navigate to="/" replace />
  }
  return children
}

// /homecare: 在宅の患者を登録 (一覧は左ペイン)
export const HomecareHome: FC = () => (
  <Gate>
    <HomecareHomePage />
  </Gate>
)

// /homecare/patients/:patientId: 患者のページ
export const HomecarePatient: FC = () => (
  <Gate>
    <HomecarePatientPage />
  </Gate>
)

// /homecare/patients/:patientId/plan: 計画書のページ
export const HomecarePlan: FC = () => (
  <Gate>
    <HomecarePlanPage />
  </Gate>
)

// /homecare/visits/:requestId: 訪問のページ (録音・SOAP・訪問報告書は薬歴のページと同じ器)
export const HomecareVisit: FC = () => (
  <Gate>
    <LatestIndexPage homecare />
  </Gate>
)
